// extracted by mini-css-extract-plugin
export default {"multi-layered-figure":"MultiLayeredFigure_multi-layered-figure__suJy1","multi-layered-figure__images":"MultiLayeredFigure_multi-layered-figure__images__GGxJU"};